import { Injectable, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';

export type DraftUserRole = 'Admin' | 'Drafter' | 'Player';

export class DraftUser {
  username: string;
  uuid: string;
  role: DraftUserRole;
  wallet: number;

  constructor(username: string, uuid: string, role: DraftUserRole = 'Player', wallet: number = 200) {
    this.username = username;
    this.uuid = uuid;
    this.role = role;
    this.wallet = wallet;
  }
}

@Injectable({ providedIn: 'root' })
export class DraftUserService {
  private injector = inject(EnvironmentInjector);

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  constructor(private db: AngularFireDatabase) {}

  addUser(user: DraftUser) {
    return this.inCtx(() => this.db.object(`/draftUsers/${user.uuid}`).set(user));
  }

  getUsers(): Observable<DraftUser[]> {
    return this.inCtx(() => this.db.list<DraftUser>('/draftUsers').valueChanges());
  }
}
